module.exports = __webpack_public_path__ + "img/round-close-sales.c70c2e94.svg";